import React, {FunctionComponent} from "react";
import ConfirmEmail from "../ConfirmTool/ConfirmEmail";
import DeleteCommission from "../DeleteCommission/DeleteCommission";
import PayPalResetTool from "../PayPalResetTool/PayPalResetTool";
import ResetMFA from "../resetMFA/ResetMFA";
import StripeResetTool from "../StripeResetTool/StripeResetTool";
import StripeRefundTool from "../StripeRefundTool/StripeRefundTool";
import "./Tools.scss";
import MessageBox from "../../../components/MessageBox/MessageBox";

const Tools: FunctionComponent = () => {
  return (<div>
      <MessageBox text="Admin Tools"/>
      <div className="tools-grid padding-inline-screen">
        <ConfirmEmail/>
        <DeleteCommission/>
        <PayPalResetTool/>
        <ResetMFA/>
        <StripeResetTool/>
        <StripeRefundTool/>
      </div>
    </div>
  );
}

export default Tools;
